import StateInterface from "../state-interface";

export const notification_queue: StateInterface["notification_queue"] = {
	_id: "",
	batch_key: "",
	chunk_index: 0,
	chunk_count: 0,
	notification_template_key: "",
	payload: {
		business_profile_id: null,
		entity_type: "",
		entity_id: "",
		data: {},
		triggered_by: {
			is_system: false,
			is_business_profile: false,
			user_id: "",
			business_profile_id: "",
		},
		source: "",
		web_url: "",
		channels_off: [],
	},
	recipients: [],
	status: "",
	attempts: 0,
	max_attempts: 0,
	locked_until: null,
	locked_by: "",
	last_error: "",
	completed_at: null,
	expires_at: null,
	created_at: "",
	updated_at: "",
};

export default notification_queue;
